import React from 'react';
import { Helmet } from 'react-helmet-async';

export const SITE_URL = 'https://vastulens.com';
export const SITE_NAME = 'VastuLens';
const DEFAULT_IMAGE = `${SITE_URL}/logo.jpg`;

/**
 * Per-page SEO tags. `path` must be the route path with a leading slash
 * (e.g. "/blog/kitchen-vastu") — it becomes the canonical URL and og:url.
 * Pass `noindex` for private/thin pages; they get no canonical.
 * `jsonLd` accepts a schema.org object or an array of them.
 */
function Seo({
  title,
  description,
  path = '/',
  image = DEFAULT_IMAGE,
  type = 'website',
  noindex = false,
  jsonLd,
}) {
  const url = `${SITE_URL}${path === '/' ? '' : path}`;
  const schemas = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
  const twitterCard = image === DEFAULT_IMAGE ? 'summary' : 'summary_large_image';

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {!noindex && <link rel="canonical" href={url} />}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {schemas.map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}

export default Seo;
